import { Tag, TagCloseButton, TagLabel } from "@biblioteksentralen/react";
import { Filter } from "./facetUtils";

export const FilterTag = ({ filter, onClick }: { filter: Filter; onClick: () => void }) => {
  return (
    <Tag size="md" borderRadius="full" variant="solid" bg="#000">
      <TagLabel>{filter.label}</TagLabel>
      <TagCloseButton id={filter.value} name={filter.label} onClick={onClick} opacity="1" />
    </Tag>
  );
};
